import React from 'react';
import { withTranslation } from 'react-i18next';
import './LanguageSelector.less';

class LanguageSelector extends React.Component {
	language = { en: 'English', ar: 'العربية', fr: 'Français' };

	switchLanguage = (toLang) => {
		const { i18n } = this.props;
		if (toLang === 'ar') {
			document.body.style.direction = "rtl";
		} else {
			document.body.style.direction = "ltr";
			
		}
		i18n.changeLanguage(toLang);
	}

	render() {
		// const { t } = this.props;
		return (
			<div className="language-selector">
				<span role="link" onClick={() => this.switchLanguage('en')}>
					{this.language.en}
				</span>
				<span role="link" onClick={() => this.switchLanguage('fr')}>
					{this.language.fr}
				</span>
				<span role="link" onClick={() => this.switchLanguage('ar')}>
					{this.language.ar}
				</span>
			</div>
		);
	}
}

export default withTranslation('translations')(LanguageSelector);
